import { runtime } from '../../runtime/Runtime';
export class AppNotification {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get notification() {
        return runtime.solidPackages.Lazy.classes.notification;
    }
    async info(data) {
        await runtime.fetchPackages.Lazy;
        this.notification.info(data);
    }
    async success(data) {
        await runtime.fetchPackages.Lazy;
        this.notification.success(data);
    }
    async error(data) {
        await runtime.fetchPackages.Lazy;
        this.notification.error(data);
    }
    async warning(data) {
        await runtime.fetchPackages.Lazy;
        this.notification.warning(data);
    }
    async open(data) {
        await runtime.fetchPackages.Lazy;
        this.notification.open(data);
    }
    async destroy() {
        await runtime.fetchPackages.Lazy;
        this.notification.destroy();
    }
    async close(key) {
        await runtime.fetchPackages.Lazy;
        this.notification.close(key);
    }
}
